import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import dig from 'object-dig';
import moment from 'moment';
import { toast } from 'react-toastify';

import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import PeopleIcon from '@material-ui/icons/People';
import SaveAlt from '@material-ui/icons/SaveAlt';
import BusinessIcon from '@material-ui/icons/Business';

import Chip from '@material-ui/core/Chip';
import LinkMaterial from '@material-ui/core/Link';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Typography from '@material-ui/core/Typography';

import Paper from '~/components/Paper';
import Dialog from '~/components/Dialog';
import Button from '~/components/Button';
import Table from '~/components/Table/Table';
import GridItem from '~/components/GridItem';
import InputDate from '~/components/Input/InputDate';
import GridContainer from '~/components/GridContainer';
import InputSearch from '~/components/Input/InputSearch';
import LinearProgress from '~/components/LinearProgress';
import tableStyles from '~/components/Table/Table/styles';
import InputControl from '~/components/Input/InputControl';
import TablePagination from '~/components/Table/TablePagination';
// import InputSelectAsync from '~/components/Input/InputSelectAsync';
import InputSwitch from '~/components/Input/InputSwitch';
import InputCheckBox from '~/components/Input/InputCheckBox';
import InputSelect from '~/components/Input/InputSelect';
import InputMultiCorporation from '~/components/Input/InputMultiCorporation';

import { showPerson } from '~/config/routes';
import Request from '~/providers/Request';

import toInt from '~/utils/Number/toInt';
import isPresent from '~/utils/isPresent';
import fetchCorporatePartner from '~/utils/fetchCorporatePartner';
import csvGenerator from '~/utils/csvGenerator';
import xlsxGenerator from '~/utils/xlsxGenerator';
import { activeOptions, packageOptions } from '~/config/constants';
import isBlank from '~/utils/isBlank';

function PackageActives() {
  const { t } = useTranslation();
  const classesTable = tableStyles();
  const [loading, setLoading] = useState(false);
  const [userActives, setUserActives] = useState([]);
  const [totalUserActives, setTotalUserActives] = useState(0);
  const [considerBranches, setConsiderBranches] = useState(false);
  const [considerAppointments, setConsiderAppointments] = useState(false);
  const [onlyDependents, setOnlyDependents] = useState(false);
  const [cumulative, setCumulative] = useState(true);
  const [corporation, setCorporation] = useState(null);
  const [dataInit, setDataInit] = useState(moment().startOf('month').format());
  const [dataEnd, setDataEnd] = useState(moment().endOf('month').format());
  const [pack, setPack] = useState('doctor');

  const [inputSearch, setInputSearch] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [fileType, setFileType] = useState('');
  const [showModalBranches, setShowModalBranches] = useState(false);
  const [loadingBranches, setLoadingBranches] = useState(false);
  const [considerAllBranches, setConsiderAllBranches] = useState(true);
  const [branches, setBranches] = useState([]);
  const [active, setActive] = useState('actives');

  const trAttr = (attr) => t(`packageActives.attributes.${attr}`);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  async function generateFile(filters, type, customNameInput) {

    let customName = '';

    if(customNameInput !== '') {
      customName = customNameInput;
    } else if(filters?.corporation_name !== '') {
      customName = filters.corporation_name;
    } else {
      customName = 'Múltiplas Empresas';
    }

    const corporation_name = filters.corporation_name;
    delete filters.corporation_name;

    try {
      const registers = await Request.get(
        '/admin/report/package_actives',
        filters,
        {
          normalizeJSON: false,
        }
      );

      const rows = [];
      rows.push([`${customName} - ${packageOptions[pack]}`.toUpperCase()]);

      let filtersStr = '';
      if (considerBranches)
        filtersStr += `${t('packageActives.extras.considerBranches')}, `;
      if (considerAppointments) filtersStr += `${t('consider_appointments')}, `;
      if (onlyDependents) filtersStr += `${t('only_dependents')}, `;
      if (cumulative) filtersStr += `${t('cumulative')}, `;

      rows.push(['Filtros', filtersStr]);
      rows.push(['']);

      rows.push([
        'Período',
        `${moment(filters.start).format('DD/MM/YYYY HH:mm')} a ${moment(
          filters.end
        ).format('DD/MM/YYYY HH:mm')}`,
      ]);
      rows.push([
        'Total Ativos',
        registers.data.filter((e) => isBlank(e.deleted_at)).length,
      ]);
      rows.push([
        'Total Inativos',
        registers.data.filter((e) => !isBlank(e.deleted_at)).length,
      ]);

      rows.push(['']);
      rows.push(['Clientes Ativos']);
      rows.push(['ID', 'Nome', 'CPF', t('responsible'), 'Data ativação', 'Empresas']);
      registers.data.map((item) => {
        if (isBlank(item.deleted_at))
          rows.push([
            item.id,
            item.name,
            item.cpf,
            item.owner_name,
            item.created_at
              ? moment(item.created_at).format('DD/MM/YYYY HH:mm')
              : null,
            item.corporation_name,
          ]);
        return item;
      });

      rows.push(['']);
      rows.push(['Clientes Inativos']);
      rows.push([
        'ID',
        'Nome',
        'CPF',
        t('responsible'),
        'Data ativação',
        'Data Inativação',
        'Empresas',
      ]);
      registers.data.map((item) => {
        if (!isBlank(item.deleted_at))
          rows.push([
            item.id,
            item.name,
            item.cpf,
            item.owner_name,
            item.created_at
              ? moment(item.created_at).format('DD/MM/YYYY HH:mm')
              : null,
            item.deleted_at
              ? moment(item.deleted_at).format('DD/MM/YYYY HH:mm')
              : null,
            item.corporation_name,
          ]);
        return item;
      });

      if (type === 'csv')
        csvGenerator(`${customName.toLocaleUpperCase()} - ${packageOptions[pack]}.csv`, [
          ...rows,
        ]);
      else
        xlsxGenerator(`${customName.toLocaleUpperCase()} - ${packageOptions[pack]}.xlsx`, [
          ...rows,
        ]);

      toast.success(
        `Arquivo ${type.toLocaleUpperCase()} de clientes gerado com sucesso!`
      );

      const totalPages = toInt(registers.meta.total) / registers.meta.perPage;
      if (registers.meta.page < totalPages) {
        filters.page += 1;
        filters.corporation_name = corporation_name;
        generateFile(filters, type, '');
      }
    } catch (error) {
      console.log(error);
      toast.error(
        `Não foi possível gerar o arquivo ${type.toLocaleUpperCase()} dos clientes`
      );
    }
  }

  function onExportWithBranches(item, type) {

    const filters = {
      start: dataInit,
      end: dataEnd,
      qs: '',
      page: 1,
      per_page: 500000,
      pack: pack,
      partners: `[${item.id}]`,
      corporations: `[${item.corporation_id}]`,
      consider_branches: false,
      consider_appointments: considerAppointments,
      only_dependents: onlyDependents,
      cumulative: cumulative,
      active,
    };

    const customName = item?.name ? item.name : '';
    generateFile(filters, type, customName);
    
  }

  function onExport(type) {
    const corpsId = corporation
      ? `[${corporation.map((corp) => corp.id).join(',')}]`
      : null;
    const corpsCorporationId = corporation
      ? `[${corporation.map((corp) => corp.corporation_id).join(',')}]`
      : null;

    const filters = {
      start: dataInit,
      end: dataEnd,
      qs: '',
      page: 1,
      per_page: 500000,
      pack: pack,
      partners: corpsId,
      corporations: corpsCorporationId,
      consider_branches: false,
      consider_appointments: considerAppointments,
      only_dependents: onlyDependents,
      cumulative: cumulative,
      active,
    };
    
    switch (considerBranches) {
      case true: 
        if(corporation && corporation.length === 1) {
          if(corporation[0]?.corporation_id === null) {
            toast.warn('Selecione uma empresa para considerar filiais.');
          } else {
            setShowModalBranches(true);
          }
        } else {
          toast.warn('Quando considerar filiais selecione apenas uma empresa.');
        }
        break;
      case false:
        if(corporation && corporation.length === 1) {
          toast.info(`Arquivo ${type.toLocaleUpperCase()} esta sendo gerado!`);
          if(corporation && corporation[0]?.name) {
            generateFile(filters, type, corporation[0].name);
          } else {
            generateFile(filters, type, 'Múltiplas Empresas');
          }
        } else {
          toast.info(`Arquivo ${type.toLocaleUpperCase()} esta sendo gerado!`);
          generateFile(filters, type, 'Múltiplas Empresas');
        }
        break;
      default:
        toast.warn('Não foi possível emitir o relatório. Tente novamente.');
        break;
    }

  }

  async function getUserActives() {
    setLoading(true);

    const corpsId = corporation
      ? `[${corporation.map((corp) => corp.id).join(',')}]`
      : null;
    const corpsCorporationId = corporation
      ? `[${corporation.map((corp) => corp.corporation_id).join(',')}]`
      : null;

    const filters = {
      start: dataInit,
      end: dataEnd,
      qs: inputSearch,
      page: page + 1,
      per_page: rowsPerPage,
      pack: pack,
      partners: corpsId,
      corporations: corpsCorporationId,
      consider_branches: considerBranches,
      consider_appointments: considerAppointments,
      only_dependents: onlyDependents,
      cumulative: cumulative,
      active,
    };

    Request.get('/admin/report/package_actives', filters, {
      normalizeJSON: false,
    })
      .then((response) => {
        const { data, meta } = response;
        setLoading(false);
        setUserActives(data);
        setPage(toInt(meta.page) - 1);
        setTotalUserActives(toInt(meta.total));
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  }

  async function getFirstCorporation() {
    fetchCorporatePartner(null, 0, () => {
      setCorporation([
        {
          corporation_id: null,
          id: null,
          name: 'Todas',
        },
      ]);
    });
  }

  async function fetchParams() {
    const url = new URLSearchParams(window.location.search);

    const corporation_id = url.get('corporation_id');
    const start = url.get('start');
    const end = url.get('end');

    if (isPresent(start)) {
      const startDate = moment(start);

      if (startDate.isValid()) {
        setDataInit(startDate.format());
      }
    }
    if (isPresent(end)) {
      const endDate = moment(end);

      if (endDate.isValid()) {
        setDataEnd(endDate.format());
      }
    }

    if (isPresent(corporation_id) && corporation_id !== 'null') {
      try {
        const { data } = await Request.get(
          `/admin/partner/${corporation_id}`,
          null,
          {
            normalizeJSON: true,
          }
        );

        setCorporation([data]);
      } catch (error) {
        console.log(error);
        toast.info(
          'Não foi possível encontrar a empresa informada por parâmetro'
        );
      }
    } else {
      getFirstCorporation();
    }
  }

  useEffect(() => {
    if (corporation && dataInit && dataEnd) {
      getUserActives();
    }
  }, [
    inputSearch,
    page,
    rowsPerPage,
    dataInit,
    dataEnd,
    corporation,
    considerBranches,
    considerAppointments,
    onlyDependents,
    cumulative,
    pack,
    active,
  ]);

  useEffect(() => {
    async function getBranches() {
      setLoadingBranches(true);
      Request.get(
        `/admin/corporation/${corporation[0].corporation_id}/branches`,
        null,
        {
          normalizeJSON: true,
        }
      )
        .then((response) => {
          const data = response.data.map((item) => {
            return {
              ...item,
              consider: true,
            };
          });
          setBranches(data);
          setLoadingBranches(false);
        })
        .catch((error) => {
          setLoadingBranches(false);
          console.log(error);
        });
    }
    if (showModalBranches && corporation) {
      getBranches();
    }
  }, [showModalBranches]);

  useEffect(() => {
    fetchParams();
  }, []);
  return (
    <>
      <Paper
        Icon={PeopleIcon}
        iconColor="blue"
        title={t('dashboard.attributes.packages_by_month')}
        subtitle={t('dashboard.attributes.packages_by_month_description')}
      >
        <GridContainer>
          <GridItem xs={12} sm={6} md={6} lg={6} xl={6}>
            <InputMultiCorporation
              corporation={corporation}
              setCorporation={setCorporation}
            />
          </GridItem>
          <GridItem xs={12} sm={3} md={3} lg={3} xl={3}>
            <InputControl
              value={dataInit}
              name="date"
              label={t('packageActives.extras.date_init')}
              inputComponent={InputDate}
              InputProps={{
                type: 'date',
              }}
              onChange={(date) => {
                setDataInit(moment(date).startOf('day').format());
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={3} md={3} lg={3} xl={3}>
            <InputControl
              value={dataEnd}
              name="date"
              label={t('packageActives.extras.date_end')}
              inputComponent={InputDate}
              InputProps={{
                type: 'date',
              }}
              onChange={(date) =>
                setDataEnd(moment(date).endOf('day').format())
              }
            />
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
            <InputControl
              name={'pack'}
              label={t('packageActives.extras.pack')}
              value={pack}
              inputComponent={InputSelect}
              onChange={({ pack }) => {
                setPack(pack);
              }}
              InputProps={{
                outValueType: 'string',
                options: Object.keys(packageOptions)
                  .filter((key) => !['doctor_all', 'pack'].includes(key))
                  .map((key) => ({ id: key, name: packageOptions[key] })),
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={2} md={2} lg={2} xl={2}>
            <InputControl
              name={'active'}
              label={t('only')}
              value={active}
              inputComponent={InputSelect}
              onChange={({ active }) => {
                setActive(active);
              }}
              InputProps={{
                outValueType: 'string',
                options: Object.keys(activeOptions).map((key) => ({
                  id: key,
                  name: activeOptions[key],
                })),
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={2} md={2} lg={2} xl={2}>
            <InputSwitch
              label={t('packageActives.extras.considerBranches')}
              value={considerBranches}
              onChange={setConsiderBranches}
            />
            <InputSwitch
              label={t('consider_appointments')}
              value={considerAppointments}
              onChange={setConsiderAppointments}
            />
            <InputSwitch
              label={t('only_dependents')}
              value={onlyDependents}
              onChange={setOnlyDependents}
            />
            <InputSwitch
              label={t('cumulative')}
              value={cumulative}
              onChange={setCumulative}
            />
          </GridItem>

          <GridItem align="right">
            <Button
              // style={{ margin: 20 }}
              color="second"
              onClick={() => {
                setFileType('csv');
                onExport('csv');
              }}
            >
              {t('action.export_csv')} <SaveAlt />
            </Button>
            <Button
              style={{ marginLeft: 10 }}
              color="orange"
              onClick={() => {
                setFileType('xlsx');
                onExport('xlsx');
              }}
            >
              {t('action.export_xlsx')} <SaveAlt />
            </Button>
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
            <InputSearch
              value={inputSearch}
              label={t('action.search')}
              placeholder={t('packageActives.extras.search')}
              onChange={setInputSearch}
            />
          </GridItem>
        </GridContainer>

        <LinearProgress loading={loading} />

        <Table
          emptyData={userActives.length === 0}
          loading={loading}
          columns={
            <>
              <TableCell className={classesTable.cell}>
                {trAttr('id')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('name')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('cpf')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('cell_phone')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('email')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('corporation')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {t('responsible')}
              </TableCell>
              <TableCell className={classesTable.cell}>{t('status')}</TableCell>
              <TableCell className={classesTable.cell}>
                {t('activated_at')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {t('inactivated_at')}
              </TableCell>
            </>
          }
        >
          {userActives.map((row) => {
            return (
              <TableRow
                key={`${row.id}-${row.corporation_name}`}
                hover
                className={classesTable.row}
              >
                <TableCell>
                  <Chip
                    label={row.id}
                    component={LinkMaterial}
                    href={showPerson.reverse({
                      id: row.id,
                    })}
                    style={{ cursor: 'pointer' }}
                    target="_blank"
                    color="primary"
                    variant="outlined"
                    onDelete={() => {}}
                    deleteIcon={<OpenInNewIcon />}
                  />
                </TableCell>
                <TableCell>{row.name}</TableCell>
                <TableCell>{row.cpf}</TableCell>
                <TableCell>{row.cell_phone}</TableCell>
                <TableCell>{row.email}</TableCell>
                <TableCell>{row.corporation_name}</TableCell>
                <TableCell>{row.owner_name}</TableCell>
                <TableCell>
                  {row.deleted_at ? t('not_active') : t('active')}
                </TableCell>
                <TableCell>
                  {row.created_at
                    ? moment(row.created_at).format('DD/MM/YYYY HH:mm')
                    : null}
                </TableCell>
                <TableCell>
                  {row.deleted_at
                    ? moment(row.deleted_at).format('DD/MM/YYYY HH:mm')
                    : null}
                </TableCell>
              </TableRow>
            );
          })}
        </Table>

        <LinearProgress loading={loading} />

        <Typography
          variant="subtitle2"
          color="primary"
          align="right"
          style={{ paddingRight: 16, marginTop: 10 }}
        >
          <strong>Total: </strong>
          {totalUserActives}
        </Typography>

        <TablePagination
          count={totalUserActives}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />

        <Dialog
          icon={<BusinessIcon />}
          isOpen={showModalBranches}
          handleClose={() => setShowModalBranches(false)}
          title={t('packageActives.extras.considerBranches')}
          dialogActions={
            <Button
              onClick={() => {
                if(branches.length === 0) {
                  toast.error('Erro ao recuperar lista de filiais');
                } else {

                  let hasFilial = false;

                  branches.map((item) => {
                    if (item.consider === true) {
                      hasFilial = true;
                      onExportWithBranches(item, fileType);
                    }
                  });

                  if(hasFilial){
                    toast.info(
                      `Arquivo ${fileType.toLocaleUpperCase()} esta sendo gerado!`
                    );
                    setShowModalBranches(false);
                  } else {
                    toast.warn('Selecione ao menos uma filial para gerar o arquivo.');
                  }
                }
              }}
              disabled={loadingBranches}
              color="primary"
            >
              {t('action.export')} <SaveAlt />
            </Button>
          }
        >
          <div style={{ minWidth: 560 }}>
            <LinearProgress loading={loadingBranches} />
            <GridContainer>
              <GridItem xs={12} sm={12} md={12} lg={12} xl={12}>
                <InputSwitch
                  label={t('packageActives.extras.considerAllBranches')}
                  value={considerAllBranches}
                  onChange={(value) => {
                    setBranches(
                      branches.map((item) => {
                        return {
                          ...item,
                          consider: value,
                        };
                      })
                    );
                    setConsiderAllBranches(value);
                  }}
                />
                <Table
                  emptyData={branches.length === 0}
                  loading={loadingBranches}
                  columns={
                    <>
                      <TableCell className={classesTable.cell}>
                        {t('packageActives.extras.consider')}
                      </TableCell>
                      <TableCell className={classesTable.cell}>
                        {trAttr('corporation')}
                      </TableCell>
                    </>
                  }
                >
                  {branches.map((row, index) => {
                    return (
                      <TableRow key={row.id} hover className={classesTable.row}>
                        <TableCell>
                          <InputControl
                            value={row.consider}
                            name="consider"
                            disabled={loading}
                            inputComponent={InputCheckBox}
                            onChange={({ consider }) => {
                              const newBranches = [...branches];
                              newBranches[index].consider = consider;

                              setBranches(newBranches);
                            }}
                          />
                        </TableCell>
                        <TableCell>{row.name}</TableCell>
                      </TableRow>
                    );
                  })}
                </Table>
              </GridItem>
            </GridContainer>
            <LinearProgress loading={loadingBranches} />
          </div>
        </Dialog>
      </Paper>
    </>
  );
}

export default PackageActives;
